export default "__VITE_ASSET__C1x5nPqQ__"